<div [ngClass]="wrapperCssClass">
  <section id="content" class="animate-fade-up page">
    <ng-content></ng-content>
  </section>
</div>
